import { Injectable, inject } from '@angular/core';

import { ClaimsService, MenuContentItem } from '@frontend/vanilla/core';
import { AccountMenuConfig } from '@frontend/vanilla/shared/account-menu';

@Injectable({ providedIn: 'root' })
export class AccountMenuVipService {
    private readonly config = inject(AccountMenuConfig);
    private readonly claimsService = inject(ClaimsService);

    get isVip(): boolean {
        return !!this.vipLevel && this.config.account.vipLevels.some((level: string) => level.toLowerCase() === this.vipLevel?.toLowerCase());
    }

    get vipLevel(): string | null {
        return this.claimsService.get('http://api.bwin.com/v3/user/vipLevel')!;
    }

    get ignoreVipLevel(): boolean {
        return this.config.account.ignoreVipLevel;
    }

    get currentVipLevelItem(): MenuContentItem {
        return this.config.vipLevels.find((o) => o.name.toLowerCase() === 'level_' + (this.vipLevel || 'nonvip').toLowerCase())!;
    }

    get vipIcon(): string {
        return this.currentVipLevelItem.image.src;
    }

    get vipUrl(): string {
        return this.currentVipLevelItem.url;
    }

    get vipLabel(): string {
        return this.currentVipLevelItem.text;
    }
}
